import { Bike, Car, Truck, Bus } from "lucide-react";
import { cn } from "@/lib/utils";
import { STATUS, timeAgo, vehicleStatus, isGpsFresh } from "@/lib/fleet";

const ICONS = { car: Car, motorcycle: Bike, truck: Truck, van: Bus };
export const VehicleTypeIcon = ({ type, className }) => {
  const I = ICONS[type] || Car;
  return <I className={className} />;
};

export function VehicleRow({ v, selected, onClick }) {
  const st = vehicleStatus(v);
  return (
    <button type="button" onClick={onClick} data-testid={`vehicle-row-${v.id}`}
      className={cn("group flex w-full items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition-colors duration-150",
        selected ? "border-primary/60 bg-primary/[0.07]" : "border-transparent hover:bg-accent")}>
      <div className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent">
        <VehicleTypeIcon type={v.type} className="h-[18px] w-[18px] text-muted-foreground" />
        <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full border-2 border-card" style={{ background: STATUS[st].hex }} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-2">
          <span className="truncate text-[13px] font-semibold">{v.name}</span>
          <span className="shrink-0 font-mono text-[12px] font-semibold">{isGpsFresh(v) ? `${Math.round(v.speed || 0)}` : "—"}<span className="ml-0.5 text-[10px] text-muted-foreground">km/j</span></span>
        </div>
        <div className="mt-0.5 flex items-center justify-between gap-2 text-[11px] text-muted-foreground">
          <span className="font-mono">{v.plate}</span>
          <span className="flex items-center gap-2">
            <span className={cn("rounded px-1 font-mono text-[9.5px] font-bold", v.acc === true ? "bg-emerald-500/15 text-emerald-500" : v.acc === false ? "bg-slate-500/15 text-slate-400" : "bg-slate-500/10 text-slate-400")}>ACC {v.acc === true ? "ON" : v.acc === false ? "OFF" : "BELUM ADA DATA"}</span>
            <span>{timeAgo(v.server_time)}</span>
          </span>
        </div>
      </div>
    </button>
  );
}
